import React from 'react'
import { useField } from 'formik'
import { CFieldProps } from '@velocity/shared'

export const FileSelectInput = ({ fileProps, ...props }: CFieldProps) => {
  const [, meta, helpers] = useField(props.name)
  const handleFileChange = (event: any) => {
    const selectedFile = event.target.files[0]
    helpers.setValue(selectedFile)
  }

  return (
    <input
      {...props}
      {...fileProps}
      onChange={handleFileChange}
      type='file'
      className={`p-1 border rounded-md w-full rounded-md ${props.disabled ? 'bg-[#EEEEEE]' : 'bg-white'} ${
        meta?.touched && meta?.error ? 'border-red-500' : 'border-gray-300'
      }`}
    />
  )
}
